module.exports = __webpack_public_path__ + "static/payoff-words-3dcc321807470f637192fe190ecdbada.mp4";